<div class="table-container">
    <!-- Top filter section -->
    <div class="filter-section">
      <div class="filter-header">
  
        <!-- Process Filter -->
        <div class="filter-box process-filter">
          <div class="filter-title">CURRENT PROCESS</div>
          <div class="dropdown-container">
            <select class="filter-dropdown medium" [(ngModel)]="selectedProcess" (ngModelChange)="onFilterChange()">
              <option value="">All Processes</option>
              <option *ngFor="let process of processesOptions; trackBy: trackByValue" [value]="process">
                {{ process }}
              </option>
            </select>
          </div>
        </div>
  
        <!-- Entity Name Filter -->
        <div class="filter-box entity-filter">
          <div class="filter-title">ENTITY NAME</div>
          <div class="dropdown-container">
            <select class="filter-dropdown medium" [(ngModel)]="selectedEntityName" (ngModelChange)="onFilterChange()">
              <option value="">All Entity Names</option>
              <option *ngFor="let entity of entityNameOptions; trackBy: trackByValue" [value]="entity">
                {{ entity }}
              </option>
            </select>
          </div>
        </div>
  
        <!-- Trigger Source Filter -->
        <div class="filter-box trigger-filter">
          <div class="filter-title">TRIGGER SOURCE</div>
          <div class="dropdown-container">
            <select class="filter-dropdown medium" [(ngModel)]="selectedTriggerSource" (ngModelChange)="onFilterChange()">
              <option value="">All Trigger Sources</option>
              <option *ngFor="let trigger of triggerSourceOptions; trackBy: trackByValue" [value]="trigger">
                {{ trigger }}
              </option>
            </select>
          </div>
        </div>
  
      </div>
    </div>
  
    <!-- Main table section -->
    <div class="table-section">
      <div class="table-layout">
        <div class="right-column">
          <table class="data-table">
            <thead>
              <tr class="header-row">
                <th>CURRENTPROCESS</th>
                <th>ENTITY NAME</th>
                <th>TRIGGER SOURCE</th>
                <th>TOTAL OFFSET</th>
                <th>CURRENT OFFSET</th>
                <th>updated date and time</th>
                <th>updated by</th>
                <th>GRAPH</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of filteredRows" class="data-row">
                <td>{{ row.process }}</td>
                <td>{{ row.entityName }}</td>
                <td>{{ row.triggerSource }}</td>
                <td>{{ row.totalOffset }}</td>
                <td>{{ row.currentOffset }}</td>
                <td>{{ row.updatedDateTime | date:'short' }}</td>
                <td>{{ row.updatedBy }}</td>
                <td class="graph-cell">
                  <app-progress-bar 
                    [totalOffset]="row.totalOffset" 
                    [currentOffset]="row.currentOffset">
                  </app-progress-bar>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  